import { commitMutation, graphql } from 'react-relay';
import { Environment } from 'relay-runtime';
import { CartUpdatePromoCodesMutation } from './__generated__/CartUpdatePromoCodesMutation.graphql';
// import pick from 'lodash/pick';

export const mutation = graphql`
  mutation CartUpdatePromoCodesMutation($input: CartUpdatePromoCodesInput!) {
    cartUpdatePromoCodes(input: $input) {
      cart {
        id
        eventHostFirstName
        eventId
        totalMinusSavings
        promoCodeIsValid
        promoCodes {
          id
          promoDescription
          code
          discountShipping
          thresholds {
            spendAmount
            spendQuantity
            discountAmount
            discountFree
            discountTax
            discountShipping
          }
        }
        wordPressCoupons {
          code
          couponDescription
          storeBalance
          yotpoCouponCode
        }
        wordPressCouponSavings
        shippingInfo {
          shippingMethod
        }
        shippingPrice
        shippingCosts {
          upsGround
          upsSecondDayAir
        }
        promoCodeSavings
        totalSavings
        total
        viaQualifiedCartTotal
        subTotalPriceOfItems
        subTotalPriceOfItemsWithPromoCodes
        taxTotal
        c4cMode
      }
    }
  }
`;

interface CommitInput {
  environment: Environment;
  promoCodes: string[];
  noGiftCards?: boolean;
  key?: string;
  onCompleted: any;
  onError: any;
}

function commit({
  environment,
  promoCodes,
  noGiftCards,
  key,
  onCompleted,
  onError,
}: CommitInput): Promise<void> {
  return new Promise((resolve, reject) => {
    return commitMutation<CartUpdatePromoCodesMutation>(environment, {
      mutation,
      variables: { input: { promoCodes, noGiftCards, key } },
      onCompleted: (...args) => {
        resolve(onCompleted(...args));
      },
      onError: error => {
        reject(onError(error));
      },
    });
  });
}

export default { commit };
